export const adminPrefix = "/admin/";

export const CONSTANTS = {
  PAGE_LIMIT: 10,
};
